import { AppBar, Tab, Tabs } from "@material-ui/core";
import { TabPanel, useTabStyle } from "App/Component/ui";
import { PRIMARY_COLOR_BUTTON } from "App/constants";
import React, { useState } from "react";
import TabBarang from "./TabBarang";
import TabJasa from "./TabJasa";
import TabFasilitas from "./TabFasilitas";
import TabRikjang from "./TabRikjang";

function a11yProps(index) {
  return {
    id: `tab-panel-${index}`,
    "aria-controls": `TabPanel-${index}`,
  };
}

const TabMaster = ({ formData, setFormData, paketID }) => {
  const classes = useTabStyle();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <div className={classes.rootTab}>
        <AppBar
          position='static'
          classes={{
            root: classes.appbar,
          }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant={"fullWidth"}
            aria-label={"Tabs Rikjang"}
            classes={{
              root: classes.tabs,
              flexContainer: classes.fixedTab,
            }}>
            <Tab
               classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='BARANG'
              {...a11yProps(0)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='JASA'
              {...a11yProps(1)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='FASILITAS'
              {...a11yProps(2)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='RIKJANG'
              {...a11yProps(3)}
            />
          </Tabs>
        </AppBar>
        <TabPanel alwaysMount={false} value={value} index={0}>
          <TabBarang
            formData={formData}
            setFormData={setFormData}
            paketID={paketID}
          />
        </TabPanel>
        <TabPanel alwaysMount={false} value={value} index={1}>
          <TabJasa
            formData={formData}
            setFormData={setFormData}
            paketID={paketID}
          />
        </TabPanel>
        <TabPanel alwaysMount={false} value={value} index={2}>
          <TabFasilitas
            formData={formData}
            setFormData={setFormData}
            paketID={paketID}
          />
        </TabPanel>
        <TabPanel alwaysMount={false} value={value} index={3}>
          <TabRikjang
            formData={formData}
            setFormData={setFormData}
            paketID={paketID}
          />
        </TabPanel>
      </div>
    </div>
  );
};

export default TabMaster;
